import TagsList from 'packages/cosell/src/components/TagsList/TagsList';
import { useMemo, memo } from 'react';
import useMsftReferral from '../hooks/useMsftReferral';
import { DealTypeMap } from './constants';
const SourceMap = {
  Incoming: 'Microsoft',
  Outgoing: 'Partner',
} as const;

/** Renders tags for MSFT referral that matches provided tackleId */
const Tags = ({ tackleId }: { tackleId: string }) => {
  const { data: referral } = useMsftReferral({ tackleId });

  const tags = useMemo(() => {
    if (!referral) return null;
    const { direction, metadata, status, substatus, id } = referral;
    return [
      {
        label: 'Source',
        value: SourceMap[direction],
      },
      {
        label: 'Type',
        value: DealTypeMap[metadata?.dealType],
      },
      {
        label: 'Status',
        value: status,
      },
      {
        label: 'Substatus',
        value: substatus,
      },
      {
        label: 'Cloud ID',
        value: id,
        copyable: true,
      },
      {
        label: 'CRM ID',
        value: metadata?.crmId,
        copyable: true,
      },
    ];
  }, [referral]);

  return tags ? <TagsList tags={tags} /> : null;
};

export default memo(Tags);
